import Vue from 'vue';
import Colcade from 'colcade';
import { gsap } from 'gsap';

Vue.component('two-column-component', {
    props: {
        events: {
            type: Array,
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            colcade: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.initColcade();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initColcade() {
            gsap.delayedCall(0.1, () => {
                console.log('init');
                this.colcade = new Colcade('.two-column__container', {
                    columns: '.two-column__column',
                    items: '.two-column__item',
                });
                console.log(this.colcade);
            });
        },

        destoryColcade() {
            if (!this.colcade) {
                return;
            }

            this.colcade.destroy();
            this.colcade = null;
        },
    },

    onDestroy() {
        this.colcade.destroy();
    },
});
